<script setup>
import { computed, getCurrentInstance } from 'vue';

// Access store via proxy
const { proxy } = getCurrentInstance();
const store = proxy.$store;

// Computed Property for User Preference
const lineNumbers = computed(() => {
    return store.getters['user/pref']('codeMirror_lineNumbers');
});

// Methods
const onClick = () => {
    store.dispatch('user/setPref', {
        name: 'codeMirror_lineNumbers',
        value: !lineNumbers.value
    });
};
</script>

<template>
    <button class="dropdown-item d-flex align-items-center" type="button" @click="onClick">
        <span
            :class="{ 'bi-square': !lineNumbers, 'bi-check-square': lineNumbers }"
            class="me-2"
        />
        Line numbers
    </button>
</template>